import '@take-2/fd-modules/desktop/search/app';
